import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=31a45967&scoped=true"
import script from "./customer-list.vue?vue&type=script&lang=js"
export * from "./customer-list.vue?vue&type=script&lang=js"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=31a45967&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a45967",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a45967')) {
      api.createRecord('31a45967', component.options)
    } else {
      api.reload('31a45967', component.options)
    }
    module.hot.accept("./customer-list.vue?vue&type=template&id=31a45967&scoped=true", function () {
      api.rerender('31a45967', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/specialty_store/form/customer-list.vue"
export default component.exports